import { render } from "./Prova.vue?vue&type=template&id=3a6026b6&scoped=true"
const script = {}

import "./Prova.vue?vue&type=style&index=0&id=3a6026b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6026b6"]])

export default __exports__